import {applicationCreateDtoCategoryEnum} from "@/modules/exam-applications/shared/types";

export const PassCategoryMapping = {
    [applicationCreateDtoCategoryEnum['1']]: { text: 'A' },
    [applicationCreateDtoCategoryEnum['2']]: { text: 'B' },
    [applicationCreateDtoCategoryEnum['3']]: { text: 'C' },
    [applicationCreateDtoCategoryEnum['4']]: { text: 'D' },
    [applicationCreateDtoCategoryEnum['5']]: { text: 'CD' },
    [applicationCreateDtoCategoryEnum['6']]: { text: 'TM' },
    [applicationCreateDtoCategoryEnum['8']]: { text: 'BC' }
};